import '../social_content_parent_post_view.js.coffee'
Monitoring.Views ||= {}

class Monitoring.Views.YoutubeContentParentPostView extends Monitoring.Views.SocialContentParentPostView

  buildQuery: =>
    @searchQuery = new Monitoring.Models.SearchQuery({}, { use_defaults: false })
    @searchQuery.addContextKind('parent_post')
    @addContextLimit()
    @searchQuery.addContentId(@rootParentId)
